import type {ThemeBreakpoints} from '_uiComponents'

const wishlist = {
    Wishlist: {
        baseStyle: ({headerSize}: {headerSize: ThemeBreakpoints}) => ({
            container: {
                pt: {
                    base: `${headerSize.base}px`,
                    sm: `${headerSize.sm}px`,
                    md: `${headerSize.md}px`,
                    lg: `${headerSize.lg}px`,
                    xl: `${headerSize.xl}px`,
                    '2xl': `${headerSize['2xl']}px`,
                },
            },
            headline: {
                px: {base: 'spacing.4', xl: 'spacing.8'},
                mb: {base: 'spacing.8', md: 0},
            },
            divider: {
                borderColor: 'color.border.grey.300',
            },
            emptyWishlistLabel: {
                textStyle: 'paragraphMd',
                fontWeight: 400,
                my: 'spacing.8',
                textAlign: 'center',
            },
            fullWidthTile: {
                colSpan: 2,
                px: {base: 0, md: '20%'},
            },
        }),
    },
}

export default wishlist
